'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Node = require('./node');

/**
 * Singleton subclass of an empty Collection.
 */

var Empty = function (_Node) {
  _inherits(Empty, _Node);

  function Empty() {
    _classCallCheck(this, Empty);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Empty).call(this));

    _this.termType = Empty.termType;
    return _this;
  }

  _createClass(Empty, [{
    key: 'toString',
    value: function toString() {
      return '()';
    }
  }]);

  return Empty;
}(Node);

Empty.termType = 'empty';

module.exports = Empty;


//////////////////
// WEBPACK FOOTER
// ./~/rdflib/lib/empty.js
// module id = 83
// module chunks = 0